import bootstrap from 'bootstrap';

class Modal {

    constructor(){
        this.init();
    }

    init() {
        const cardModals = document.querySelectorAll('.card .card-body .modalLink');
        const carouselLinks = document.querySelectorAll('.carousel-link'); //links that open a carousel in a modal

        if(cardModals!== null)
        {
            cardModals.forEach((item, index)  => {
                const targetId = item.getAttribute('data-bs-target');
                const targetToggleType = item.getAttribute('data-bs-toggle');
                if(targetId !== null){
                    var imageLinks = document.querySelectorAll('.modalContainerCards .card')[index];
                    if(imageLinks!=null)
                    {  
                        var links = imageLinks.querySelectorAll('.card-link');
                        links.forEach(link =>
                        {
                            if(link!==null && link!== undefined)
                            {
                                link.setAttribute("data-bs-target", targetId);
                                link.setAttribute("data-bs-toggle", targetToggleType);
                            }
                        })
                    }
                }
            });
        }
        if(carouselLinks != null){
            carouselLinks.forEach((link) => {
                const targetModal = link.getAttribute('data-bs-target');
                const targetCarouselId = document.querySelector(targetModal + ' .carousel').id;
                const targetSlide = link.getAttribute('data-bs-slide-to');
                let carousel = new bootstrap.Carousel(document.getElementById(targetCarouselId));
               
                link.addEventListener('click', ()=>{
                    carousel.to(targetSlide);
                }) 
            
            })
        }
    }
}

export default Modal;